/**
 * Delays the execution for the specified number of milliseconds.
 * @param ms - The number of milliseconds to wait.
 * @returns A promise that resolves after the specified delay.
 */
export function wait(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
